import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { filterToCriteria, ILeadViewFilter } from '../../aida/entities/LeadView/useLeadView';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useLeadServedExportMutation({
	onSuccess = () => toast.success('You will receive an email when your export is ready to be downloaded.'),
	onError = (error: Api.IOperationResultNoValue) => toast.error(error?.systemMessage ?? 'Unable to export calls'),
	onSettled,
}: {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSettled?: () => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (filter: ILeadViewFilter) =>
			userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: 'leadServed/export' }),
				'POST',
				{ filter: { criteria: filterToCriteria(filter) }, includeTranscription: true }
			),
		onError,
		onSettled,
		onSuccess,
	});
}
